var exports = {
  "k": "x31de4314--639497--container",
};

module.exports = exports;
